import React, { useEffect, useState } from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

const CustomerDetail = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const [customer, setCustomer] =
    useState({});

  const [rentals, setRentals] =
    useState([]);

  const customerPhoto =
    rentals?.[0]?.customer_photo;

  // =========================================
  // FETCH DATA
  // =========================================

  useEffect(() => {

    fetch(
      `/api/customers`
    )
      .then(res => res.json())
      .then(data => {

        const found =
          data.customers?.find(
            c => c.id == id
          );

        setCustomer(found || {});
      });

    fetch(
      `/api/customer-rentals/${id}`
    )
      .then(res => res.json())
      .then(data => {

        setRentals(
          data.rentals || []
        );
      });

  }, [id]);

  // =========================================
  // DATE FORMAT
  // =========================================

  const formatDate = (date) => {

    if (!date) return "-";

    return new Date(date)
      .toLocaleDateString("en-GB");
  };

  // =========================================
  // RENTAL STATUS
  // =========================================

  const getStatus = (r) => {

  // BACKEND STATUS PRIORITY

  if (r.status === "returned") {
    return "Returned";
  }

  if (r.status === "partial_return") {
    return "Partial Return";
  }

  if (r.status === "active") {

    const today =
      new Date()
        .toISOString()
        .split("T")[0];

    if (r.return_date < today) {
      return "Overdue";
    }

    if (r.return_date === today) {
      return "Due Today";
    }

    return "Active";
  }

  return r.status || "Active";
};

  // =========================================
  // RENTAL STATUS COLORS
  // =========================================

  const getStatusClass =
    (status) => {

      if (status === "Returned") {
        return "bg-green-100 text-green-700";
      }

      if (
        status === "Partial Return"
      ) {
        return "bg-yellow-100 text-yellow-700";
      }

      if (status === "Overdue") {
        return "bg-red-100 text-red-700";
      }

      if (status === "Due Today") {
        return "bg-orange-100 text-orange-700";
      }

      return "bg-blue-100 text-blue-700";
    };

  // =========================================
  // PAYMENT STATUS COLORS
  // =========================================

  const getPaymentStatusClass =
    (status) => {

      if (status === "paid") {
        return "bg-green-100 text-green-700";
      }

      if (status === "partial") {
        return "bg-yellow-100 text-yellow-700";
      }

      return "bg-red-100 text-red-700";
    };

  // =========================================
  // TOTAL PENDING
  // =========================================

  const totalPending =
    rentals.reduce(

      (sum, r) =>

        sum +

        Number(
          r.pending_amount || 0
        ),

      0
    );

  return (

   <div className="min-h-screen bg-[#F5F7FB] p-4 md:p-6 space-y-6">

      {/* ========================================= */}
      {/* HERO */}
      {/* ========================================= */}

      <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-3xl p-5 md:p-8 text-white shadow-xl">

        <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-6">

          <div className="flex flex-col sm:flex-row items-center sm:items-center gap-6 text-center sm:text-left">

            {/* CUSTOMER PHOTO */}

            {customerPhoto ? (

              <img
                src={`/uploads/customer_photos/${customerPhoto}`}
                alt="Customer"
               className="w-20 h-20 md:w-24 md:h-24 rounded-3xl object-cover border-4 border-white shadow-lg"
              />

            ) : (

              <div className="w-20 h-20 md:w-24 md:h-24 rounded-3xl bg-white/20 backdrop-blur-md flex items-center justify-center text-2xl md:text-3xl font-bold border border-white/20">

                {customer?.first_name?.[0]}

              </div>

            )}

            {/* INFO */}

            <div>

              <p className="uppercase tracking-widest text-indigo-200 text-sm">

                Customer Management

              </p>

             <h1 className="text-2xl md:text-4xl font-bold mt-2">

                {customer?.first_name}
                {" "}
                {customer?.last_name}

              </h1>

              <p className="text-indigo-100 mt-3">

                Rental customer profile and transaction history

              </p>

            </div>

          </div>

          {/* STATS */}

          <div className="hidden lg:flex gap-4">

            <div className="bg-white/10 backdrop-blur-md px-6 py-5 rounded-2xl border border-white/20 min-w-[180px]">

              <p className="text-sm text-indigo-100">
                Total Rentals
              </p>

              <h2 className="text-4xl font-bold mt-2">

                {rentals.length}

              </h2>

            </div>

            <div className="bg-white/10 backdrop-blur-md px-6 py-5 rounded-2xl border border-white/20 min-w-[180px]">

              <p className="text-sm text-indigo-100">
                Pending Amount
              </p>

              <h2 className="text-4xl font-bold mt-2">

                ₹{totalPending}

              </h2>

            </div>

          </div>

        </div>

      </div>

      {/* ========================================= */}
      {/* CUSTOMER INFO */}
      {/* ========================================= */}

     <div className="bg-white rounded-3xl p-5 md:p-8 shadow-sm border border-gray-100">

        <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4 mb-8">

          <div>

            <h2 className="text-2xl font-bold text-gray-800">

              Customer Information

            </h2>

            <p className="text-sm text-gray-500 mt-1">

              Personal and contact details

            </p>

          </div>

          <div className="bg-indigo-100 text-indigo-600 px-4 py-2 rounded-xl text-sm font-semibold">

            Customer Profile

          </div>

        </div>

        {/* INFO GRID */}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

          {/* FULL NAME */}

          <div className="bg-gray-50 rounded-2xl p-5 border border-gray-100">

            <p className="text-sm text-gray-500 mb-2">

              Full Name

            </p>

            <h3 className="text-lg font-semibold text-gray-800">

              {customer?.first_name}
              {" "}
              {customer?.last_name}

            </h3>

          </div>

          {/* PHONE */}

          <div className="bg-gray-50 rounded-2xl p-5 border border-gray-100">

            <p className="text-sm text-gray-500 mb-2">

              Phone

            </p>

            <h3 className="text-lg font-semibold text-gray-800">

              {customer?.phone || "-"}

            </h3>

          </div>

          {/* ADDRESS */}

          <div className="bg-gray-50 rounded-2xl p-5 border border-gray-100">

            <p className="text-sm text-gray-500 mb-2">

              Address

            </p>

            <h3 className="text-lg font-semibold text-gray-800">

              {customer?.address || "-"}

            </h3>

          </div>

        </div>

      </div>

      {/* ========================================= */}
      {/* RENTALS TABLE */}
      {/* ========================================= */}

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">

        {/* HEADER */}

        <div className="px-5 md:px-8 py-6 border-b border-gray-100 flex flex-col sm:flex-row justify-between sm:items-center gap-4">

          <div>

            <h2 className="text-2xl font-bold text-gray-800">

              Customer Rentals

            </h2>

            <p className="text-sm text-gray-500 mt-1">

              Rental history and payment tracking

            </p>

          </div>

          <div className="bg-indigo-100 text-indigo-600 px-4 py-2 rounded-xl text-sm font-semibold">

            {rentals.length}
            {" "}
            Rentals

          </div>

        </div>

        {/* TABLE */}

        <div className="overflow-x-auto">

         <table className="min-w-[900px] w-full">

            <thead className="bg-gray-50 text-gray-500 text-sm">

              <tr>

                <th className="text-left px-8 py-5">
                  Rental ID
                </th>

                <th className="text-left px-6 py-5">
                  Rent Date
                </th>

                <th className="text-left px-6 py-5">
                  Return Date
                </th>

                <th className="text-left px-6 py-5">
                  Rental Status
                </th>

                <th className="text-left px-6 py-5">
                  Payment Status
                </th>

                <th className="text-right px-8 py-5">
                  Actions
                </th>

              </tr>

            </thead>

            <tbody>

              {rentals.length === 0 ? (

                <tr>

                  <td
                    colSpan="8"
                    className="py-20 text-center text-gray-500"
                  >

                    No rentals found

                  </td>

                </tr>

              ) : (

                rentals.map(r => {

                  const status =
                    getStatus(r);

                  return (

                    <tr
                      key={r.id}
                      className="border-t border-gray-100 hover:bg-gray-50 transition"
                    >

                      {/* ID */}

                      <td className="px-8 py-6">

                        <span className="font-semibold text-gray-800">

                          #{r.id}

                        </span>

                      </td>

                      {/* RENT DATE */}

                      <td className="px-6 py-6 text-gray-700">

                        {formatDate(
                          r.rent_date
                        )}

                      </td>

                      {/* RETURN DATE */}

                      <td className="px-6 py-6 text-gray-700">

                        {formatDate(
                          r.return_date
                        )}

                      </td>

                      {/* RENTAL STATUS */}

                      <td className="px-6 py-6">

                        <span
                          className={`px-4 py-2 rounded-full text-xs font-semibold
                            ${getStatusClass(status)}
                          `}
                        >

                          {status}

                        </span>

                      </td>

                      {/* PAYMENT STATUS */}

                      <td className="px-6 py-6">

                        <span
                          className={`px-4 py-2 rounded-full text-xs font-semibold
                            ${getPaymentStatusClass(
                              r.payment_status
                            )}
                          `}
                        >

                          {

                            r.payment_status === "paid"

                              ? "Paid"

                              : r.payment_status === "partial"

                              ? "Partial"

                              : "Unpaid"

                          }

                        </span>

                      </td>

                      {/* ACTIONS */}

                     <td className="px-8 py-6 text-right whitespace-nowrap space-x-3">

                        <button
                          onClick={() =>
                            navigate(
                              `/rental/${r.id}`
                            )
                          }
                          className="whitespace-nowrap bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-5 py-3 rounded-2xl font-medium hover:shadow-lg transition"
                        >

                          View

                        </button>

                        <button
                          onClick={() =>
                            window.open(
                              `/invoice/${r.id}`
                            )
                          }
                          className="whitespace-nowrap border border-gray-200 hover:bg-gray-100 px-5 py-3 rounded-2xl font-medium transition"
                        >

                          Invoice

                        </button>

                      </td>

                    </tr>
                  );
                })

              )}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
};

export default CustomerDetail;